import GrupoValidacionesCreate from './GrupoValidacionesCreate';
import GrupoValidacionesEdit from './GrupoValidacionesEdit';
import GrupoValidacionesList from './GrupoValidacionesList';
import GrupoValidacionesShow from './GrupoValidacionesShow';

const indexGrupoValidaciones = {
    list: GrupoValidacionesList,
    create: GrupoValidacionesCreate,
    edit: GrupoValidacionesEdit,
    show: GrupoValidacionesShow,
};

export default indexGrupoValidaciones;
